let language = {
    // 店铺连接状态
    "STORE-STATUS-ACTIVE": "活跃",
    "STORE-STATUS-CLOSE": "不活跃",
    "STORE-STATUS-DRAFT": "草稿",

    "STORE-STATUS-CONNECTING": "连接中",
    "STORE-STATUS-CONNECTED": "已连接",
    "STORE-STATUS-UNEXPECTED": "未知错误",
    "STORE-STATUS-CONNECT-FAIL": "连接失败",
    "STORE-STATUS-AUTHORIZATION-FAIL": "授权失败",
    "STORE-STATUS-INVALID-URL": "无效的URL",
    "STORE-STATUS-MISSING": "缺少授权",
    "STORE-STATUS-INVALID-SHOP": "无效的商店",
    "STORE-STATUS-INVALID-PLUGIN": "无效的插件",
    "STORE-STATUS-WAIT-UPGRADE": "等待升级",
    // 店铺连接状态popover
    "POPOVER-STORE-STATUS-CONNECTING": "您的商店正在连接中，如果长时间没有响应，请刷新此页面",
    "POPOVER-STORE-STATUS-CONNECTED": "连接成功",
    "POPOVER-STORE-STATUS-UNEXPECTED": "连接到您的商店时发生未知错误。请检查以下内容：确保您的网站地址正确并可在互联网上访问。允许访问您的电子商店的读写权限。",
    "POPOVER-STORE-STATUS-CONNECT-FAIL": "您可以点击此标签尝试重新连接",
    "POPOVER-STORE-STATUS-AUTHORIZATION-FAIL": '请到右侧的"操作"中的"设置"重新授权',
    "POPOVER-STORE-STATUS-INVALID-URL": '请到右侧的"操作"中的"设置"重新填写您的URL',
    "POPOVER-STORE-STATUS-MISSING": '请到右侧的"操作"中的"设置"重新授权',
    "POPOVER-STORE-STATUS-INVALID-SHOP": "请确保您已成功注册一个商店",
    "POPOVER-STORE-STATUS-INVALID-PLUGIN": "请确保您已在Shopify中安装我们的插件",

    "POPOVER-STORE-CURRENCY-UNSUPPORTED-TIP": "不支持商店中的默认货币。 请更新您的默认货币设置以继续同步。",
    "POPOVER-STORE-CURRENCY-PRODUCT-INCONFORMITY-TIP": "{{appName}}上的店铺产品货币设置与您的商店默认货币不匹配。 ",

    // 产品页选择店铺
    "PRODUCT-STORE-ADD-TITLE": "将产品添加到商店",
    "PRODUCT-STORE-MODAL-MAIN-TITLE": "选择商店",
};

export { language }
